var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"layout__col-2-1 header header--space-between"},[_c('PageHeaderMenuItems'),_vm._v(" "),_c('DeviceSelector',{attrs:{"device-type-selected":_vm.deviceTypeSelected},on:{"selected":_vm.actionSetDeviceTypeSelected}}),_vm._v(" "),_c('PageActions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }